import Routing from "./Routing";

const App = () => {
	return (
		<Routing />
	);
};

export default App;
